import { render, staticRenderFns } from "./BasePillGroup.vue?vue&type=template&id=ece81820"
import script from "./BasePillGroup.vue?vue&type=script&lang=js"
export * from "./BasePillGroup.vue?vue&type=script&lang=js"
import style0 from "./BasePillGroup.vue?vue&type=style&index=0&id=ece81820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports